module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "photo-modal modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header border-bottom-0 py-1 relative-position"
  }, [_c('h5', {
    staticClass: "photo-no modal-title text-center w-100"
  }, [_vm._v(_vm._s(_vm.targetPhoto.photo_no))]), _vm._v(" "), _c('img', {
    staticClass: "btn-close-mg",
    attrs: {
      "data-dismiss": "modal",
      "src": require("assets/close_btn.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body px-1 pt-0 pb-3"
  }, [_c('div', {
    staticClass: "row mx-1-gutters"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    ref: "imageAreaFrame",
    staticClass: "photo-image-area"
  }, [_c('div', {
    ref: "imageAreaWrap",
    staticClass: "photo-image-wrap h-100 w-100 relative-position",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.photoImageUrl),
      expression: "photoImageUrl"
    }],
    ref: "imageArea",
    staticClass: "photo-image"
  })])])]), _vm._v(" "), (_vm.isVertically) ? _c('div', {
    staticClass: "col-4 vertical-operation-flex-wrap"
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-end h-100 vertical-operation-flex"
  }, [_c('div', {
    staticClass: "text-center pb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('button', {
    staticClass: "p-0 btn float-left",
    staticStyle: {
      "background-color": "transparent",
      "color": "#82ba1d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prevImage
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "p-0 btn float-right",
    staticStyle: {
      "background-color": "transparent",
      "color": "#82ba1d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextImage
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()])]), _vm._v(" "), (!_vm.isVertically) ? _c('div', {
    staticClass: "modal-footer border-top-0 pt-0"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn p-0",
    staticStyle: {
      "background-color": "transparent",
      "color": "#82ba1d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prevImage
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn p-0",
    staticStyle: {
      "background-color": "transparent",
      "color": "#82ba1d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextImage
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-012b4f1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/OrderDownloadPhotoImageModal.vue
// module id = 663
// module chunks = 0